var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12404 3.50011C9.12404 3.01687 9.51639 2.62452 9.99964 2.62452C10.4827 2.62456 10.8743 3.01644 10.8745 3.49942L10.8739 9.1252H16.4989C16.9822 9.1252 17.3739 9.51686 17.3739 10.0001C17.3738 10.4834 16.9822 10.875 16.4989 10.875H10.8739L10.8745 16.4994C10.8745 16.9827 10.4822 17.375 9.99895 17.375C9.51603 17.3747 9.12413 16.9831 9.12404 16.5001V10.875H3.49895C3.01591 10.8748 2.62404 10.4832 2.62404 10.0001C2.62404 9.51701 3.01591 9.12544 3.49895 9.1252H9.12404V3.50011Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.a39df61b3aaf7e590421e36250ac0da3.svg";
export { ForwardRef as ReactComponent };